import React, { useState, useEffect } from 'react';
import styles from './Header.module.css';
import classes from 'classnames';
import { Link, NavLink } from "react-router-dom";

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        }
    }, [menuOpen]);

    return (
        <header className={styles.header}>
            <div className={classes(styles.header__container, '_container')}>

                <div className={styles.header__logo}>
                    <Link to="/home" className={styles.logo__link}>
                        <img
                            src="/images/Logo.jpg"
                            alt="header"
                            className={styles.logo__images}
                        />
                    </Link>
                </div>

                {/* БУРГЕР */}
                <button
                    className={classes(
                        styles.burger,
                        menuOpen && styles.burger_active
                    )}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Open menu"
                >
                    <span />
                    <span />
                    <span />
                </button>

                {/* МЕНЮ */}
                <nav
                    className={classes(
                        styles.header__menu,
                        menuOpen && styles.header__menu_open
                    )}
                >
                    <ul className={styles.menu__list}>
                        <li className={styles.menu__item}>
                            <NavLink to="/home" className={styles.menu__link} onClick={() => setMenuOpen(false)}>Home</NavLink>
                        </li>
                        <li className={styles.menu__item}>
                            <NavLink to="/current" className={styles.menu__link} onClick={() => setMenuOpen(false)}>Current</NavLink>
                        </li>
                        <li className={styles.menu__item}>
                            <NavLink to="/archives" className={styles.menu__link} onClick={() => setMenuOpen(false)}>Archives</NavLink>
                        </li>
                        <li className={styles.menu__item}>
                            <NavLink to="/indexing" className={styles.menu__link} onClick={() => setMenuOpen(false)}>Indexing</NavLink>
                        </li>
                        <li className={styles.menu__item}>
                            <NavLink to="/editorial" className={styles.menu__link} onClick={() => setMenuOpen(false)}>
                                Editorial Team
                            </NavLink>
                        </li>
                        <li className={styles.menu__item}>
                            <NavLink to="/publication" className={styles.menu__link} onClick={() => setMenuOpen(false)}>
                                Publication Ethics
                            </NavLink>
                        </li>
                        <li className={styles.menu__item}>
                            <NavLink to="/announcements" className={styles.menu__link} onClick={() => setMenuOpen(false)}>
                                Announcements
                            </NavLink>
                        </li>
                        <li className={styles.menu__item}>
                            <NavLink to="/contact" className={styles.menu__link} onClick={() => setMenuOpen(false)}>
                                Contact
                            </NavLink>
                        </li>
                        <li className={styles.menu__item}>
                            <NavLink to="/submissions" className={styles.menu__link} onClick={() => setMenuOpen(false)}>
                                Submissions
                            </NavLink>
                        </li>
                    </ul>
                </nav>

            </div>
        </header>
    );
};

export default Header;
